import React from 'react'

import { connect } from 'react-redux'

import debounce from 'debounce'

import {
    Row,
    Col,
    Table,
    Icon,
    Input,
    Button,
    InputNumber,
    Card,
    Divider,
    Badge,
    Popconfirm
} from 'antd'

import {
    _getCategoryFeatures
} from '../../../services'

import {
    setCategoryFeatures,
    addCategoryFeature,
    updateCategoryFeatureValue,
    deleteCategoryFeature,
    toggleCategoryFeatureActive
} from '../actions'

const pageSize = 10

class CategoryFeatureList extends React.Component {
    render(){

        const { 
            current,
            total
        } = this.state

        const columns = [{
            title: "Name",
            dataIndex: 'name',
            render:(name, categoryFeature)=>{
                return (
                    <Input
                        style={{
                            width: 300
                        }}
                        defaultValue={name}
                        onChange={(e)=>this.handleNameChange({ name: e.target.value, categoryFeatureId: categoryFeature._id })}
                    />
                )
            }
        },{
            title: "Active",
            dataIndex: 'active',
            render: (active, categoryFeature) => {

                const status = active?'success':'error'
                const text = active?"Active":"Inactive"

                return (
                    <Badge
                        style={{
                            cursor: 'pointer'
                        }}
                        onClick={()=>this.handleToggleActive(categoryFeature._id)}
                        status={status}
                        text={text}
                    />
                )

            }
        },{
            title: "Actions",
            dataIndex: "_id",
            render:(categoryFeatureId) => {
                return (
                    <Row type="flex">
                        <Col>
                            <a 
                                target="_blank"
                                href={`/category-feature/${categoryFeatureId}`}
                            >Edit</a>
                        </Col>
                        <Divider type="vertical"/>
                        <Col>
                            <Popconfirm
                                title="Confirm delete?"
                                onConfirm={()=>this.handleDelete(categoryFeatureId)}
                            >
                                <a>Delete</a>
                            </Popconfirm>
                        </Col>
                    </Row>
                )
            }
        },{
            title: "Order",
            dataIndex: 'order',
            render: (order, categoryFeature) => {
                return (
                    <InputNumber
                        defaultValue={order}
                        onChange={(order) => this.handleOrderChange({ order, categoryFeatureId: categoryFeature._id})}
                    />
                )
            }
        }]

        return(
            <Card style={{margin: 24}}>
                <Row 
                style={{marginBottom: 16}}
                type="flex"
                justify="space-between"
                >
                    <Col>

                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={this.handleAdd}
                        >
                            <Icon type="plus"/> Add
                        </Button>
                    </Col>
                </Row>
                <Table
                    loading={this.props.loading}
                    columns={columns}
                    pagination={{
                        pageSize,
                        current,
                        total,
                        onChange: (nextPage) => this.setState({ current: nextPage }, this.setCategoryFeatures)
                    }}
                    dataSource={this.props.data}
                />
            </Card>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            searchParam: '',
            current: 1,
            total: 0
        }

        this.handleNameChange = debounce(this.handleNameChange, 1000)

    }

    componentDidMount(){

        this.setCategoryFeatures()

    }

    setCategoryFeatures = () => {

        const {
            current,
            searchParam
        } = this.state

        this.props.setCategoryFeatures({
            searchParam,
            pageSize,
            current
        })

    }

    handleNameChange = ({ categoryFeatureId, name }) => {

        this.props.updateCategoryFeatureValue({
            categoryFeatureId,
            key: 'name',
            value: name
        })
    }

    handleOrderChange = ({ categoryFeatureId, order }) => {

        this.props.updateCategoryFeatureValue({
            categoryFeatureId,
            key: 'order',
            value: order
        })
    }

    handleToggleActive = (categoryFeatureId) => {

        this.props.toggleCategoryFeatureActive(categoryFeatureId)
    }

    handleAdd = () => {
        this.props.addCategoryFeature()
    }

    handleDelete = (categoryFeatureId) => {
        this.props.deleteCategoryFeature(categoryFeatureId)
    }

}

export default connect(
    state => ({
        data: state.categoryFeatures.data,
        loading: state.categoryFeatures.loading
    }),
    dispatchEvent => ({
        addCategoryFeature: () => dispatchEvent(addCategoryFeature()),
        setCategoryFeatures: (inputObj) => dispatchEvent(setCategoryFeatures(inputObj)),
        updateCategoryFeatureValue: (categoryFeature) => dispatchEvent(updateCategoryFeatureValue( categoryFeature)),
        deleteCategoryFeature: (categoryFeatureId) => dispatchEvent(deleteCategoryFeature(categoryFeatureId)),
        toggleCategoryFeatureActive: (categoryFeatureId) =>dispatchEvent(toggleCategoryFeatureActive(categoryFeatureId))
    })
)(CategoryFeatureList)


// WEBPACK FOOTER //
// ./src/components/category-feature/list/index.js